import React, { Component } from 'react';
import './ResultAnalysisSubMenuBar.css'

export default class ResultAnalysisSubMenuBar extends Component {
    handleOnClick = (section) => (e) => {
        this.props.onMenuChange(section);
    }
    render() {
        const { section, subsection } = this.props;
        return (
            <div className="ResultAnalysisSubMenuBar">
                <ul>
                    { section==="price" &&
                        <React.Fragment>
                        <li className={subsection==="0" ? "selected" : ""} onClick={this.handleOnClick('0')}>5分足</li>
                        <li className={subsection==="1" ? "selected" : ""} onClick={this.handleOnClick('1')}>日足</li>
                        <li className={subsection==="2" ? "selected" : ""} onClick={this.handleOnClick('2')}>週足</li>
                        <li className={subsection==="3" ? "selected" : ""} onClick={this.handleOnClick('3')}>月足</li>
                        </React.Fragment>
                    }
                    { section==="estimate" &&
                        <React.Fragment>
                        <li className={subsection==="0" ? "selected" : ""} onClick={this.handleOnClick('0')}>コンセンサスレーティング</li>
                        <li className={subsection==="1" ? "selected" : ""} onClick={this.handleOnClick('1')}>売上高</li>
                        <li className={subsection==="2" ? "selected" : ""} onClick={this.handleOnClick('2')}>経常利益</li>
                        <li className={subsection==="3" ? "selected" : ""} onClick={this.handleOnClick('3')}>当期利益</li>
                        <li className={subsection==="4" ? "selected" : ""} onClick={this.handleOnClick('4')}>PER</li>
                        </React.Fragment>
                    }
                    { section==="corpinfo" &&
                        <React.Fragment>
                        {/* <li className={subsection==="0" ? "selected" : ""} onClick={this.handleOnClick('0')}>ニュース</li> */}
                        <li className={subsection==="1" ? "selected" : "selected"} onClick={this.handleOnClick('1')}>企業概況</li>
                        </React.Fragment>
                    }
                </ul>
            </div>
        );
    }

}